import React from 'react';
import { useLocation } from 'react-router';

import styled from '@emotion/styled';

import RightChevronIcon from '../Icons/RightChevronIcon';
import { InternalNavLink } from '../Link/Link';

interface IPath {
  name: string;
  link: string;
}

interface IBreadCrumbs {
  pathData: IPath[];
}

const BreadCrumbs: React.FC<IBreadCrumbs> = ({ pathData }) => {
  const { pathname } = useLocation();

  return (
    <Container>
      {pathData.map((item, index) => {
        return (
          <React.Fragment key={index}>
            {index / 2 !== 0 && <RightChevronIcon />}
            <>
              {`${item.link}` === pathname ? (
                <LinkShell
                  className={`${item.link}` === pathname ? 'active' : ''}
                >
                  {item.name}
                </LinkShell>
              ) : (
                <InternalNavLink to={item.link}>
                  <LinkShell
                    className={`${item.link}` === pathname ? 'active' : ''}
                  >
                    {item.name}
                  </LinkShell>
                </InternalNavLink>
              )}
            </>
          </React.Fragment>
        );
      })}
    </Container>
  );
};

export default BreadCrumbs;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  color: ${({ theme }) => theme.palette.mediumGrayText};
  margin-bottom: 14px;

  @media (max-width: 884px) {
    width: 100%;
    flex-wrap: wrap;
  }
`;

const LinkShell = styled.div`
  display: flex;
  cursor: pointer;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.mediumGrayText};
  font-weight: 400;

  &.active {
    color: ${({ theme }) => theme.palette.neutralGray};
    font-weight: 500;
    padding: 3.5px 8px;
    cursor: default;
    background-color: white;
    border: 1px solid ${({ theme }) => theme.palette.borderColor};
    border-radius: 4px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 16.8px;
  }
`;
